import React, { Component } from "react";
import Pic from "./assets/img/wu.png";
import "./MsUnAuth.scss";

class UnAuth extends Component {

  public render() {
    return (
      <div className="no-auth">
        <div>
          <span>抱歉，您暂无收入发放应用权限！</span>
          <br />
          <span>如需开通请联系您的签约专员或拨打客服电话</span><span>400-820-9911</span>
        </div>
        <img src={Pic} />
      </div>
    )
  }
}

export default UnAuth


// WEBPACK FOOTER //
// ./src/components/ms-unauth/MsUnAuth.tsx